var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('statistic-card-with-area-chart',{attrs:{"icon":"KeyIcon","statistic":'$'+_vm.dFormatter(_vm.refTVL),"color":"success","statistic-title":"Total Value Locked","chart-data":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }